import React, { useCallback } from 'react'

import { bool, number, string } from 'prop-types'

import CheckoutInfoCard from 'Pods/Shared/CheckoutInfoCard/CheckoutInfoCard'
import I18n from 'Pods/Shared/I18n'

import formatPrice from 'Utils/formatPrice'

import { PLAN_ANNUAL, PLAN_MONTHLY } from '../../Constants/plans'

const TERMS_KEY_PREFIX = 'subscription_checkout.terms'
const RESTRUCTURE_TERMS_KEY_PREFIX = 'subscription_checkout.plans_restructure.terms'

function termsKeysFor(planKey, isPlansRestructure) {
  if (isPlansRestructure) {
    // TODO(CU-124g39pd19u): confirm the annual refund sentence ("Annual payments are not refunded") with Ignas.
    const prefix = `${RESTRUCTURE_TERMS_KEY_PREFIX}.${planKey === PLAN_ANNUAL ? PLAN_ANNUAL : PLAN_MONTHLY}`
    return { titleKey: `${prefix}.title`, bodyKeys: [`${prefix}.body`] }
  }

  if (!planKey) {
    return {
      titleKey: `${TERMS_KEY_PREFIX}.title`,
      bodyKeys: [`${TERMS_KEY_PREFIX}.body_start`, `${TERMS_KEY_PREFIX}.body_end`],
    }
  }

  // Essentials (yearly) and Premium share one annual terms block; only monthly differs.
  const prefix = `${TERMS_KEY_PREFIX}.${planKey === PLAN_MONTHLY ? 'monthly' : 'annual'}`
  return { titleKey: `${prefix}.title`, bodyKeys: [`${prefix}.body`] }
}

function SubscriptionTerms({
  price, locale = 'en', planKey = null, isPlansRestructure = false,
}) {
  const translate = useCallback(
    (key, options = {}) => I18n.t(key, { ns: 'rails', lng: locale, ...options }),
    [locale],
  )

  const { titleKey, bodyKeys } = termsKeysFor(planKey, isPlansRestructure)
  const formattedPrice = formatPrice(price)
  const body = bodyKeys.map((key) => translate(key, { price: formattedPrice })).join('')

  // Body comes from a local i18n bundle (trusted copy, not user-supplied); it embeds links,
  // so it is rendered as HTML. Keep the same XSS posture as the prior implementation.
  return (
    <CheckoutInfoCard title={translate(titleKey)}>
      <p className="subscription-terms__body">
        {/* eslint-disable-next-line react/no-danger */}
        <span dangerouslySetInnerHTML={{ __html: body }} />
      </p>
    </CheckoutInfoCard>
  )
}

SubscriptionTerms.propTypes = {
  price: number.isRequired,
  locale: string,
  planKey: string,
  isPlansRestructure: bool,
}

export default SubscriptionTerms
